import React, { useEffect } from "react";

import ModelViewers from "./ModelViewers";
import { scrollMenuToTop } from "./menuScroll";

import BackButton from "./BackButton";


// The viewers of one model, Modelo 1 or Modelo 0, behind its own button of
// the menu; the same group for either, fed its own viewers. Its special
// viewers open from within it, and their "Regresar" comes back here. Whether
// they are open is MenuLatest's, which opens them when the page loads on one.
export default function MenuModel(props) {
    const { viewers, setActiveMenuButton, handleBack, showSpecials, onToggleSpecials, handleButtonClick, activeMenuButton, location, dataViewers } = props;

    // Opening its Datos Canales, or coming back from them, starts at the top.
    useEffect(() => {
        scrollMenuToTop();
    }, [showSpecials]);

    useEffect(() => {
        if (viewers.length > 0) {
            if (activeMenuButton === '') {
                const first = viewers.find(viewer => viewer.population !== 'people') || viewers[0];
                setActiveMenuButton(first.id)
                localStorage.setItem("selectedMenuButton", first.id)
            }

            // The month a route belongs to: a button is drawn for the Hogares
            // viewer of its pair, so a Personas viewer marks its counterpart's.
            const slug = (location.pathname).split('/')[2];
            const current = dataViewers.find(viewer => viewer.slug === slug);
            if (current) {
                const button = current.population === 'people'
                    ? dataViewers.find(viewer => viewer.id === current.counterpart) || current
                    : current;
                setActiveMenuButton(button.id)
                localStorage.setItem("selectedMenuButton", button.id)
            }
        }
    }, [viewers, dataViewers, location.pathname, activeMenuButton, setActiveMenuButton]);

    return (
        <>
            {showSpecials ? null : (
                <BackButton onClick={handleBack} />
            )}
            <ModelViewers
                viewers={viewers}
                open={showSpecials}
                onToggle={onToggleSpecials}
                handleButtonClick={handleButtonClick}
                activeMenuButton={activeMenuButton}
                dataViewers={dataViewers}
            />
        </>
    );
}